"use strict";

exports.__esModule = true;
exports.HistogramTableWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _DataTable = require("../DataTable");
var _HistogramTableElement = require("./HistogramTableElement");
var _HistogramTableFields = require("./HistogramTableFields");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var defaultDurationRange = [{
  from: 0,
  unit: "minute"
}, {
  from: 15,
  unit: "minute"
}, {
  from: 30,
  unit: "minute"
}, {
  from: 1,
  unit: "hour"
}, {
  from: 4,
  unit: "hour"
}, {
  from: 8,
  unit: "hour"
}];
var HistogramTableWidget = exports.HistogramTableWidget = {
  name: "HistogramTable",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "HistogramTableWidget.label",
    defaultMessage: "Histogram Table"
  }),
  icon: "th-list",
  group: _widgetGroups.METRIC_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "HistogramTable",
      props: Object.assign({
        dataSource: "",
        dataRange: "",
        durationRange: defaultDurationRange,
        width: 512,
        height: 512,
        configuration: {
          enablePagination: true,
          defaultPageSize: 10
        }
      }, props, {
        pageSizes: [10, 25, 50, 100]
      }),
      children: []
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 320,
      min: 32,
      max: 1024
    },
    height: {
      "default": 320,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_HistogramTableElement.HistogramTableElement),
    Fields: _HistogramTableFields.HistogramTableFields,
    Thumbnail: _DataTable.DataTableThumbnail
  }
};